'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForecasterProfile = function ForecasterProfile(_ref) {
  var alt = _ref.alt,
      forecasterName = _ref.forecasterName,
      forecasterTitle = _ref.forecasterTitle,
      text = _ref.text,
      url = _ref.url,
      styles = _ref.styles;

  var defaultUrl = 'https://www.gravatar.com/avatar/d41d8cd98f00b204e9800998ecf8427e?d=mm';
  return _react2.default.createElement(
    'div',
    { className: 'quiver-forecaster-profile', style: styles },
    _react2.default.createElement(
      'div',
      { className: 'quiver-forecaster-profile__image-container' },
      _react2.default.createElement('img', {
        src: (url || defaultUrl) + '&s=60',
        alt: alt || 'Surfline Avatar'
      })
    ),
    _react2.default.createElement(
      'div',
      { className: 'quiver-forecaster-profile__details-container' },
      _react2.default.createElement(
        'span',
        { className: 'quiver-forecaster-profile__update-text' },
        text || null
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'span',
        { className: 'quiver-forecaster-profile__forecaster-name' },
        forecasterName || null
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'span',
        { className: 'quiver-forecaster-profile__forecaster-title' },
        forecasterTitle || null
      )
    )
  );
};

ForecasterProfile.propTypes = {
  alt: _propTypes2.default.string,
  forecasterName: _propTypes2.default.string,
  forecasterTitle: _propTypes2.default.string,
  styles: _propTypes2.default.string,
  text: _propTypes2.default.string,
  url: _propTypes2.default.string
};

exports.default = ForecasterProfile;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/ForecasterProfile/ForecasterProfile.js
// module id = 585
// module chunks = 11